<template>
  <div class="beautiful">
    <div class="town">
      <p style="margin-left:.2rem;color: #ffa000;">所在乡镇-{{nowTown}}</p>
      <span class="el-dropdown-link" style="margin-right:.2rem;" @click="show">
        其它乡镇
        <i class="el-icon-arrow-right"></i>
      </span>
      <div class="motai" v-show="motai" @click="hide">
        <div class="motai-box" v-show="townMotai" @click.stop>
          <div v-for="town in towns" :key="town.TownShip1" @click.stop="hide(town.TownShip1)">
            <img src="@/assets/index/dutyWork/dp-sy-jx5.png" alt />
            <span>{{town.TownShip1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="img-box">
      <div class="img-left">
        <div
          class="img-template"
          v-for="(townImg,index) in townImgL"
          :key="index"
          @click="goimgMsg(townImg)"
        >
          <img :src="townImg.photo | img" alt />
          <p>{{townImg.headline}}</p>
        </div>
      </div>
      <div class="img-right">
        <div
          class="img-template"
          v-for="(townImg,index) in townImgR"
          :key="index"
          @click="goimgMsg(townImg)"
        >
          <img :src="townImg.photo | img" alt />
          <p>{{townImg.headline}}</p>
        </div>
      </div>
      <div class="img-msg" v-if="imgMsg.show">
        <div class="img-msg-box">
          <img :src="imgMsg.img | img" />
          <p>{{imgMsg.sceneName}}</p>
          <p>{{imgMsg.introduce}}</p>
        </div>
        <i class="el-icon-circle-close" @click="closeimgMsg"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      towns: "",
      nowTown: "",
      motai: false,
      townMotai: false,
      townImgL: [],
      townImgR: [],
      imgMsg: {
        show: false,
        img: "",
        sceneName: "",
        introduce: ""
      },
      pager: 1
    };
  },
  mounted: function() {
    if (sessionStorage.getItem("township") == "") {
      this.nowTown = "大石桥街道";
    } else {
      this.nowTown = sessionStorage.getItem("township");
    }
    this.axios
      .get("/api/Main/getTownship")
      .then(e => {
        if (e.data.code == 0) {
          this.towns = e.data.msg;
          this.hide(this.nowTown);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    hide(type) {
      if (typeof type == "string") {
        this.nowTown = type;
        let box = document.querySelector(".beautiful");
        box.scrollTop = 0;
        this.axios
          .get(`/api/Main/Home?township=${this.nowTown}&pager=${this.pager}`)
          .then(e => {
            console.log(e.data);
            this.townImgL = [];
            this.townImgR = [];
            if (e.data.code == 0) {
              let tempTown = e.data.msg;
              let homeTownVaild = tempTown.filter(item => {
                return item.photo != null;
              });
              for (let x = 0; x < homeTownVaild.length; x++) {
                if (x < homeTownVaild.length / 2) {
                  this.townImgL.push(homeTownVaild[x]);
                } else {
                  this.townImgR.push(homeTownVaild[x]);
                }
              }
            } else {
              (this.townImgL = []), (this.townImgR = []);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
      this.motai = false;
      this.townMotai = false;
    },
    show() {
      this.motai = true;
      this.townMotai = true;
    },
    goimgMsg(msg) {
      this.imgMsg.img = msg.photo;
      this.imgMsg.sceneName = msg.headline;
      // this.imgMsg.introduce = msg.introduce;
      this.imgMsg.show = true;
      this.motai = true;
    },
    closeimgMsg() {
      this.motai = false;
      this.imgMsg.show = false;
    }
  },
  filters: {
    filterB: function(value) {
      if (value != "" && value != undefined) {
        value = value.split(",")[0];
        return `http://dpadmin.djplus.cn/Pimg/${value}`;
      } else {
        return require("@/assets/index/dp-kong.png");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.beautiful {
  .img-box {
    .img-msg {
      i {
        color: #fff;
        font-size: 0.8rem;
      }
      position: fixed;
      width: 94%;
      top: 2.5rem;
      text-align: center;
      z-index: 11;
      .img-msg-box {
        img {
          width: 100%;
          height: 4.6rem;
        }

        p {
          width: 94%;
          margin: 0.2rem auto;
          text-align: left;
          &:nth-child(2) {
            font-size: 0.32rem;
            font-weight: bold;
          }
          &:nth-child(3) {
            font-size: 0.28rem;
            color: #666666;
          }
        }
        padding-bottom: 0.2rem;
        border-radius: 0.08rem;
        background: #fff;
      }
    }
    position: relative;
    display: flex;
    justify-content: space-between;
    .img-left {
      width: 50%;
      margin-right: 0.2rem;
      .img-template {
        position: relative;
        text-align: center;
        margin-top: 0.3rem;
        width: 100%;
        &:nth-child(1) {
          img {
            width: 100%;
            height: 2rem;
          }
        }
        &:not(:nth-child(1)) {
          img {
            width: 100%;
            height: 4rem;
          }
        }
        p {
          width: 100%;
          position: absolute;
          bottom: 0.05rem;
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
          background: rgba($color: #000000, $alpha: 0.2);
        }
      }
    }
    .img-right {
      width: 50%;
      .img-template {
        position: relative;
        text-align: center;
        margin-top: 0.3rem;
        width: 100%;
        img {
          width: 100%;
          height: 4rem;
        }
        p {
          width: 100%;
          position: absolute;
          bottom: 0.05rem;
          line-height: 1.5;
          color: #fff;
          background: rgba($color: #000000, $alpha: 0.2);
        }
      }
    }

    width: 94%;
    margin: 0.8rem auto;
  }
  .town {
    .motai {
      .motai-box {
        div {
          &:nth-child(odd) {
            border-right: 0.01rem solid #e6e6e6;
          }
          img {
            width: 0.25rem;
            height: 0.26rem;
            margin-right: 0.1rem;
          }
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 0.01rem solid #e6e6e6;
          text-align: center;
          height: 1rem;

        }
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows: repeat(auto-fit, 1rem);
        width: 70%;
        background: #fff;
        position: absolute;
        height: 81vh;
        right: 0;
        overflow-y: scroll;
        top: 0.9rem;
      }
      position: fixed;
      width: 100%;
      top: 0;
      height: 100vh;
      background: rgba($color: #000000, $alpha: 0.2);
      z-index: 5;
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
    position: fixed;
    top: 0.9rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    line-height: 3;
    background: #fff;
    z-index: 10;
  }
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 0.3rem;
  padding-top: 0.9rem;
  height: 100vh;
  overflow-y: scroll;
}
</style>